// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reg-privacy { padding: 15px;}\n.are-privacy { max-width: 1110px; margin: 0 auto; padding: 15px; background-color: #fff; font-size: 15px; letter-spacing: 2px;}\n.are-privacy > .img-logo { display: block; max-width: 50%; margin: 0 auto;}\n.are-privacy > .h1-privacy-title,\n.are-privacy > .h2-privacy-title { font-size: 20px; font-weight: bolder;}\n.are-privacy .txt-privacy-phase { padding-left: 20px;}\n", ""]);
// Exports
module.exports = exports;
